/* Dropmagic Asset | Version: 1.0.0 */
if (!customElements.get('dm-product-hero-section')) {
  customElements.define(
    'dm-product-hero-section',
    class ProductHero extends HTMLElement {
      constructor() {
        super();
        this.setListeners();
      }

      setListeners() {
        this.addEventListener('click', (event) => {
          const mediaElement = event.target.closest('[data-media-id]');
          if (mediaElement && mediaElement.closest('[data-dm-element="product-images-gallery"]')) {
            this.handleMediaClick(mediaElement);
            // const mediaId = mediaElement.getAttribute('data-media-id');
          }
        }, true);
      }

      _createVideoElement(sourceVideoElement) {
        const newVideo = document.createElement('video');
        sourceVideoElement.querySelectorAll('source').forEach((source) => {
          const newSource = document.createElement('source');
          newSource.src = source.src;
          newSource.type = source.type || 'video/mp4';
          newVideo.appendChild(newSource);
        });

        newVideo.playsInline = true;
        newVideo.autoplay = true;
        newVideo.loop = true;
        newVideo.muted = true;
        newVideo.defaultMuted = true;
        newVideo.controls = true;
        newVideo.preload = 'auto';
        newVideo.poster = sourceVideoElement.poster;
        newVideo.setAttribute('playsinline', '');
        newVideo.setAttribute('autoplay', '');
        newVideo.setAttribute('loop', '');
        newVideo.setAttribute('muted', '');
        newVideo.setAttribute('aria-label', sourceVideoElement.getAttribute('aria-label') || 'Product video');

        return newVideo;
      }

      _setImageSource(targetImage, sourceImage) {
        const sourceUrl = new URL(sourceImage.getAttribute('src'), document.baseURI);
        const widths = [375, 550, 750, 950, 1200, 1600, 2000, 2400];
        const imageUrl = (width) => {
          const url = new URL(sourceUrl);
          url.searchParams.set('width', width);
          return url.href;
        };

        targetImage.sizes = '(min-width: 1024px) 46vw, 100vw';
        targetImage.srcset = widths.map(width => `${imageUrl(width)} ${width}w`).join(', ');
        targetImage.src = imageUrl(2400);
        targetImage.alt = sourceImage.alt || '';
      }

      _createImageElement(sourceImageElement) {
        const newImage = document.createElement('img');
        this._setImageSource(newImage, sourceImageElement);
        return newImage;
      }

      _replaceMediaElement(targetContainer, newElement, oldElement) {
        newElement.className = oldElement.className;
        newElement.style.cssText = oldElement.style.cssText; // Use cssText for styles
        oldElement.remove();
        targetContainer.appendChild(newElement);
        if (newElement instanceof HTMLVideoElement) {
          newElement.load();
          const playPromise = newElement.play();
          if (playPromise) playPromise.catch(() => {});
        }
      }

      _prepareMainMedia(mediaElement) {
        if (mediaElement instanceof HTMLImageElement) {
          this._setImageSource(mediaElement, mediaElement);
          return;
        }

        mediaElement.playsInline = true;
        mediaElement.autoplay = true;
        mediaElement.loop = true;
        mediaElement.muted = true;
        mediaElement.defaultMuted = true;
        mediaElement.controls = true;
        mediaElement.preload = 'auto';
        mediaElement.setAttribute('playsinline', '');
        mediaElement.setAttribute('autoplay', '');
        mediaElement.setAttribute('loop', '');
        mediaElement.setAttribute('muted', '');
        mediaElement.load();
        const playPromise = mediaElement.play();
        if (playPromise) playPromise.catch(() => {});
      }

      _prepareGalleryMedia(mediaElement) {
        if (mediaElement instanceof HTMLImageElement) {
          mediaElement.sizes = '32vw';
          return;
        }

        mediaElement.pause();
        mediaElement.autoplay = false;
        mediaElement.preload = 'none';
        mediaElement.removeAttribute('autoplay');
      }

      handleMediaClick(clickedMediaElement) {
        const targetMediaContainer = document.querySelector('div#product-hero-main-image');
        if (!targetMediaContainer) return; // Exit if target container not found

        const clickedMedia = clickedMediaElement.querySelector('img, video');
        const currentMainMedia = targetMediaContainer.querySelector('img, video');
        if (!clickedMedia || !currentMainMedia) return;

        const mainClassName = currentMainMedia.className;
        const mainMediaId = targetMediaContainer.getAttribute('data-media-id');
        const mainStyle = currentMainMedia.style.cssText;
        const galleryClassName = clickedMedia.className;
        const galleryMediaId = clickedMediaElement.getAttribute('data-media-id');
        const galleryStyle = clickedMedia.style.cssText;

        targetMediaContainer.appendChild(clickedMedia);
        clickedMediaElement.appendChild(currentMainMedia);

        clickedMedia.className = mainClassName;
        clickedMedia.style.cssText = galleryStyle;
        currentMainMedia.className = galleryClassName;
        currentMainMedia.style.cssText = mainStyle;

        targetMediaContainer.setAttribute('data-media-id', galleryMediaId || '');
        clickedMediaElement.setAttribute('data-media-id', mainMediaId || '');

        this._prepareMainMedia(clickedMedia);
        this._prepareGalleryMedia(currentMainMedia);
      }
    }
  );
}
